export default __webpack_public_path__ + "static/media/gallery_03.6cf028e7.jpg";